<template>
  <div class="create-substitute-form">
    <CAlert
      v-if="reqResponse.message"
      class="mt-2 mb-4"
      :color="reqResponse.type"
      :show="!!reqResponse.message"
    >
      {{ reqResponse.message }}
    </CAlert>
    <div class="form-group">
      <VSelect
        v-model="form.user_initials"
        :class="{ 'is-invalid': reqResponse.errors['user_initials'] }"
        class="cs-select mb-2 ps__child--consume"
        :options="user_initials"
        placeholder="Title: none"
        :clearable="false"
        :reduce="(item) => item.value"
        label="label"
      >
        <template #footer>
          <div
            v-if="reqResponse.errors['user_initials']"
            class="invalid-feedback"
          >
            {{ reqResponse.errors["user_initials"][0] }}
          </div>
        </template>
      </VSelect>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input
          v-model="form.first_name"
          type="text"
          class="form-control"
          :class="{
            'is-invalid':
              v$.form.first_name.$error || reqResponse.errors['first_name']
          }"
          placeholder="First Name"
        />
        <div
          v-if="v$.form.$error && v$.form.first_name.required.$invalid"
          class="invalid-feedback"
        >
          This field is required
        </div>
        <div v-if="reqResponse.errors['first_name']" class="invalid-feedback">
          {{ reqResponse.errors["first_name"][0] }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input
          v-model="form.last_name"
          type="text"
          class="form-control"
          :class="{
            'is-invalid':
              v$.form.last_name.$error || reqResponse.errors['last_name']
          }"
          placeholder="Last Name"
        />
        <div
          v-if="v$.form.$error && v$.form.last_name.required.$invalid"
          class="invalid-feedback"
        >
          This field is required
        </div>
        <div v-if="reqResponse.errors['last_name']" class="invalid-feedback">
          {{ reqResponse.errors["last_name"][0] }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <div v-if="editableSubstitute" class="form-group">
        <VSelect
          v-model="form.status"
          :class="{ 'is-invalid': reqResponse.errors['status'] }"
          class="cs-select ps__child--consume"
          :options="user_statuses"
          placeholder="Status"
          :clearable="false"
          :reduce="(item) => item.value"
          label="label"
        >
          <template #footer>
            <div v-if="reqResponse.errors['status']" class="invalid-feedback">
              {{ reqResponse.errors["status"][0] }}
            </div>
          </template>
        </VSelect>
      </div>

      <div class="form-group mb-1">
        <input
          v-model="form.pin"
          type="text"
          class="form-control"
          :class="{
            'is-invalid': v$.form.pin.$error || reqResponse.errors['pin']
          }"
          placeholder="Enter the PIN"
        />
        <div
          v-if="v$.form.$error && v$.form.pin.required.$invalid"
          class="invalid-feedback"
        >
          This field is required
        </div>
        <div v-if="reqResponse.errors['pin']" class="invalid-feedback">
          {{ reqResponse.errors["pin"][0] }}
        </div>
      </div>

      <div class="text-end">
        <HelpCenterButton
          width="18"
          height="18"
          classes="me-2"
          content-key="form_add_substitute_pin_only"
        />
      </div>
      <div class="text-start">
        <div class="d-sm-inline-block text-center generate-pin-btn">
          <CButton
            class="me-2 p-small bg-gradient-blue reverse"
            @click="generatePIN()"
          >
            <span
              class="btn px-3 py-1"
              :class="isInView ? 'bg-main-bg' : 'bg-white '"
              ><b class="text-graident-blue reverse">Generate PIN</b></span
            >
          </CButton>
        </div>
      </div>
    </div>

    <div
      v-if="editableSubstitute && editableSubstitute.id"
      class="d-flex justify-content-center"
    >
      <div @click="submit()">
        <CLoadingButton
          :spinner="isLoading"
          :disabled="isLoading"
          :loading="isLoading"
          class="me-2 btn bg-gradient-blue text-white"
        >
          Update
        </CLoadingButton>
      </div>
      <div class="ms-2" @click="cancelEdit()">
        <CButton class="me-2 btn-gradient-border">
          <span class="btn px-4"><b class="text-graident-blue">Cancel</b></span>
        </CButton>
      </div>
    </div>
    <div v-else class="text-center" @click="submit(true)">
      <CLoadingButton
        :spinner="isLoading"
        :loading="isLoading"
        class="me-2 mb-2 btn bg-gradient-blue reverse text-white"
      >
        Submit
      </CLoadingButton>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { required } from "vuelidate/lib/validators"
import axios from "axios"
import { mapGetters } from "vuex"
import HelpCenterButton from "@/components/HelpCenterButton"

export default {
  name: "CreateSubstituteForm",
  components: { HelpCenterButton },
  props: ["isInView"],
  emits: ["substituteCreated"],
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isMounted: false,
      isLoading: false,
      form: {
        user_initials: null,
        first_name: "",
        last_name: "",
        pin: "",
        status: 1
      },
      user_initials: [
        { value: null, label: "Title: None" },
        { value: "Mr.", label: "Mr." },
        { value: "Mrs.", label: "Mrs." },
        { value: "MSgt", label: "MSgt" },
        { value: "Ms.", label: "Ms." },
        { value: "Mx.", label: "Mx." },
        { value: "Miss", label: "Miss" },
        { value: "Dr.", label: "Dr." },
        { value: "Principal", label: "Principal" },
        { value: "Assistant Principal", label: "Assistant Principal" },
        { value: "Dean of Students", label: "Dean of Students" },
        { value: "Br.", label: "Br." },
        { value: "Sr.", label: "Sr." },
        { value: "Cpt", label: "Cpt" },
        { value: "Maj", label: "Maj" },
        { value: "Lt Col", label: "Lt Col" },
        { value: "Col", label: "Col" },
        { value: "Sgt", label: "Sgt" },
        { value: "SSG", label: "SSG" },
        { value: "SFC", label: "SFC" },
        { value: "Coach", label: "Coach" },
        { value: "Rabbi", label: "Rabbi" }
      ],
      user_statuses: [
        { value: 1, label: "Active" },
        { value: 0, label: "Inactive" }
      ],
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  computed: {
    ...mapGetters({
      editableSubstitute: "users/editableSubstitute"
    }),
    isValid() {
      return !this.v$.form.$invalid
    }
  },
  watch: {
    editableSubstitute: function (user) {
      this.resetForm()
      this.resetResponseMessages()
      this.setFormByUserRecord(user)
    },
    $route: function () {
      this.cancelEdit()
    }
  },
  created() {
    this.cancelEdit()
    this.form.user_initials = this.user_initials[0].value
    this.form.status = this.user_statuses[0]
  },
  mounted() {
    this.isMounted = true
  },
  validations: {
    form: {
      first_name: { required },
      last_name: { required },
      pin: { required }
    }
  },
  methods: {
    submit(isCreate) {
      this.resetResponseMessages()
      if (this.isValid) {
        if (!isCreate) {
          this.updateSubstitute(this.editableSubstitute.id)
        } else {
          this.addSubstitute()
        }
      } else {
        this.v$.$touch()
      }
    },
    addSubstitute() {
      this.isLoading = true
      this.$store
        .dispatch("users/createSubstituteTeacher", {
          ...this.form,
          status: this.form.status.value
        })
        .then((response) => {
          const data = response.data
          if (data) {
            this.$store.commit("users/PUSH_USER", data.data)
            this.setSuccessResponse("Successfully created.")
          }
          this.isLoading = false
          this.resetForm()
          setTimeout(() => {
            this.$emit("substituteCreated")
            this.resetResponseMessages()
          }, 1000)
        })
        .catch((err) => {
          this.isLoading = false
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
        })
    },
    updateSubstitute(userId) {
      this.isLoading = true
      const data = this.form
      this.$store
        .dispatch("users/updateSubstituteTeacher", { userId, data })
        .then(() => {
          this.isLoading = false
          this.setSuccessResponse("Successfully updated.")
          this.resetForm()
          setTimeout(() => {
            this.cancelEdit()
            this.resetResponseMessages()
          }, 1000)
        })
        .catch((err) => {
          this.isLoading = false
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
        })
    },

    generatePIN() {
      axios.get("/admin/users/pin/get/").then((response) => {
        const data = response.data
        if (data) {
          this.form.pin = data.random_pin
        }
      })
    },
    setFormByUserRecord(user) {
      if (user) {
        this.form.user_initials = user.user_initials
        this.form.first_name = user.first_name
        this.form.last_name = user.last_name
        this.form.pin = user.pin ? user.pin.pin : ""
        this.form.status = Object.prototype.hasOwnProperty.call(user, "status")
          ? user.status
          : this.form.status
      }
    },
    cancelEdit() {
      this.$store.commit("users/SET_EDITABLE_SUBSTITUTE", null)
      this.resetForm()
      this.resetResponseMessages()
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    resetForm() {
      if (this.isMounted) {
        this.v$.$reset()
      }
      this.form = {
        user_initials: "",
        first_name: "",
        last_name: "",
        pin: "",
        status: this.user_statuses[0]
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    }
  }
}
</script>

<style></style>
